import styled, { css } from "styled-components";
import * as Type from "../../../../../common-deprecated/styles/lexus/Type";
import { Backdrop } from "../../../../../common-deprecated/styles/v2/lexus/components/Backdrop";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.article`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-width: 150px;
`;

export const Border = styled(Wrapper)<{ showCursorPointer?: boolean; hideBorder?: boolean }>`
    position: relative;
    justify-content: flex-start;
    cursor: ${({ showCursorPointer }) => (showCursorPointer ? "pointer" : "default")};

    ${Backdrop} {
        z-index: ${theme.zIndex.fixed};
    }

    &::after {
        display: ${({ hideBorder }) => (hideBorder ? "none" : "block")};
        position: absolute;
        right: -12px;
        width: 1px;
        height: 100%;
        content: "";
        background: ${theme.colors.platinumMedium};
    }

    html[dir="rtl"] & {
        &::after {
            left: -12px;
            right: auto;
        }
    }
`;

export const ImageWrapper = styled.div`
    display: inline-block;
    width: 100px;
    height: 47px;
    @supports (object-fit) {
        object-fit: contain;
        object-position: center;
    }
`;

export const Title = styled.div`
    width: 100%;
    margin-bottom: ${theme.space[1]}px;
    padding-right: ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: ${theme.colors.azure};
    overflow: hidden;

    ${Type.Strong} {
        font-family: ${theme.fonts.regular};
        font-size: 1.6rem;
        line-height: 2.2rem;
        color: ${theme.colors.azure};
    }

    html[dir="rtl"] & {
        padding-left: ${theme.space[3]}px;
        padding-right: 0;
    }
`;

export const CarTitle = styled.div`
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-overflow: ellipsis;
    color: ${theme.colors.azure};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */
`;

export const Subtitle = styled.h2.attrs(() => ({
    className: "l-nano-text",
}))`
    margin-bottom: 0;
    padding-right: ${theme.space[5]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    letter-spacing: 0.1rem;
    line-height: 2.2rem;
    text-overflow: ellipsis;
    color: ${theme.colors.steel};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */

    html[dir="rtl"] & {
        padding-left: ${theme.space[5]}px;
        padding-right: 0;
    }
`;

export const EngineNameTitle = styled.h2.attrs(() => ({
    className: "l-nano-text",
}))`
    margin-bottom: 0;
    padding-right: ${theme.space[5]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    letter-spacing: 0.1rem;
    line-height: 2.2rem;
    text-overflow: ellipsis;
    color: ${theme.colors.steel};
    white-space: normal;
    overflow: hidden;
    /* stylelint-disable */
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    /* stylelint-enable */

    html[dir="rtl"] & {
        padding-left: ${theme.space[5]}px;
        padding-right: 0;
    }
`;

export const CloseButton = styled.div`
    margin-right: 0;

    html[dir="rtl"] & {
        margin-left: 0;
    }
`;

export const IconHolder = styled.div`
    display: flex;
    position: absolute;
    top: 50%;
    right: ${theme.space[1]}px;
    align-items: flex-start;
    width: 24px;
    transform: translateY(-50%);
    cursor: pointer;
    .icon {
        padding: 0;
        line-height: 1;
    }

    html[dir="rtl"] & {
        left: ${theme.space[1]}px;
        right: auto;
    }
`;

export const Placeholder = styled.div<{ isLoading?: boolean }>`
    position: relative;
    margin: 0;
    overflow: hidden;

    &::before {
        height: 0;
        padding-top: 56.25%; /* Aspect ratio 16:9 */
        content: "";
    }

    img {
        width: auto;
        max-height: 100%;
    }

    svg {
        width: 100%;
        height: 100%;
        max-height: 128px;
        opacity: 0.125;
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            padding-top: 52%;
        `}
`;

export const PrevImage = styled.div<{ show?: boolean; transition?: string }>`
    transition: ${({ transition }) => transition};
    opacity: ${({ show }) => (show ? 1 : 0)};
`;
